/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination1OfOperatorPriceChangeLogAdminDto } from '../models/Pagination1OfOperatorPriceChangeLogAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OperatorPriceChangesService {
    /**
     * **Required Policy:** `ViewOperatorPriceChanges`
     * @returns Pagination1OfOperatorPriceChangeLogAdminDto OK
     * @throws ApiError
     */
    public static getOperatorPriceChangesAdmin({
        branchId,
        fromDate,
        toDate,
        page,
        limit,
    }: {
        branchId?: number,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfOperatorPriceChangeLogAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/operatorpricechanges',
            query: {
                'branchId': branchId,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
